// src/services/settings.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const scholarshipBooksApi = createApi({
  reducerPath: "scholarship-book",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_URL}/api/scholarship-books/`,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getScholarshipDataByCity: builder.query({
      query: (cityId) => `${cityId}`,
      skip: (cityId) => !cityId,
    }),
  }),
});

export const {
  useGetScholarshipDataByCityQuery,
  useLazyGetScholarshipDataByCityQuery,
} = scholarshipBooksApi;
export default scholarshipBooksApi;
export { scholarshipBooksApi };
